import { useEffect, useState } from 'react'
import { useHistory } from 'react-router'
import { connect } from 'react-redux'

import ActionCard from './component/actioncards/ActionCard.js'
import remoteStyle from './remote.module.css'
import Jyostick from './component/joystick/Joystick.js'
import zingimage from '../../../../../Assets/humanoid/ZingImage.png'
import zingimage3 from '../../../../../Assets/humanoid/ZingImage3x.png'
import hexapodImage from '../../../../../Assets/hexapod/HexapodMain@3x.png'
import unicodeToChar from '../../../../../utils/unicodeToChar.js'
import MainHeader from '../../../../ReusableComponents/Header/MainHeader.jsx'
import RemSlider from '../../../../ReusableComponents/RemSlider/RemSlider.js'

import { sendBytes } from '../../../../ReusableComponents/ByteTransfer/byteTransfer.js'
import {
    ZingByteCodes,
    HexapodByteCodes,
} from '../../../../ReusableComponents/ByteTransfer/byteCodes.js'
import {
    ZingPlayFrames,
    isZingPlayFrame,
    isZingPlayFrameVersion,
} from '../../../../ReusableComponents/ByteTransfer/zingPlayFrame.js'
import { useRef } from 'react'
import cacheAssets from '../../../../../utils/cacheAssets.js'
import renderImage from '../../../../../source/importImg.js'
import { getConnectedDeviceImage } from '../../../../../hooks/useBrandConfig'
import { cond } from 'lodash'
import { includes } from '../../../../../redux/reducers/data.js'
import { languageWords } from '../../../../../utils/langaugeSupport.js'
import { zingFreeFallSendBytes } from '../../../../../utils/freeFallBytes.js'
import Toast from '../../../../ReusableComponents/UI/Toast.jsx'
import DialogModal from '../../../../ReusableComponents/DialogModal/DialogModal.jsx'
import {
    convertFileArrFormat,
    getListFile,
    getMountPoint,
} from '../../../../../utils/readWriteFile.js'
import JoystickAutoMode from './component/JoystickAutoMode.js'

const ACTIONS = {
    HUMANOID: [
        { name: 'Attention', action: 'Attention' },
        { name: 'Side Kick', action: 'SideKickLeft' },
        { name: 'Side Kick', action: 'SideKickRight' },
        { name: 'Salute', action: 'Salute' },
        { name: 'Dance', action: 'Dance' },
        { name: 'Wave', action: 'Wave' },
        { name: 'Front Kick', action: 'FrontKickLeft' },
        { name: 'Front Kick', action: 'FrontKickRight' },
        { name: 'Fight', action: 'Fight' },
        { name: 'PushUp', action: 'PushUp' },
    ],
    HEXAPOD: [
        { name: 'Attention', action: 'Attention' },
        { name: 'Slide Left', action: 'SlideLeft' },
        { name: 'Slide Right', action: 'SlideRight' },
        { name: 'High Walking', action: 'HighWalking' },
        { name: 'Wave', action: 'Greeting' },
        { name: 'Turn around', action: 'TurnAround' },
        { name: 'Fight', action: 'Fight' },
        { name: 'Stalk Action', action: 'Stalk' },
        { name: 'Attack', action: 'Attack' },
        { name: 'Defend', action: 'Defence' },
        { name: 'Dance', action: 'Dance' },
        { name: 'Leg Roll', action: 'LegRoll' },
    ],
}

const DANCES = {
    HUMANOID: [
        { name: 'Dance 1', action: 'Dance1', isDefault: true },
        { name: 'Dance 2', action: 'Dance2', isDefault: true },
        { name: 'Dance 3', action: 'Dance3', isDefault: true },
        { name: 'Dance 4', action: 'Dance4', isDefault: true },
        // { name: 'Dance 5', action: 'Dance5' },
    ],
}

const ORIGINAL_ACTION_STATE = {
    HUMANOID: {
        isAttention: false,
        isSideKickLeft: false,
        isSideKickRight: false,
        isSalute: false,
        isDance: false,
        isWave: false,
        isForwardKickLeft: false,
        isForwardKickRight: false,
        isFight: false,
        isPushUp: false,
        isDance1: false,
        isDance2: false,
        isDance3: false,
        isDance4: false,
        isDance5: false,
    },
    HEXAPOD: {
        isAttack: false,
        isSlideLeft: false,
        isSlideRight: false,
        isHighWalking: false,
        isDance: false,
        isDefence: false,
        isTurnAround: false,
        isStalk: false,
        isGreeting: false,
        isFight: false,
        isAttention: false,
        isLegRoll: false,
    },
}
const ByteCodes = {
    HUMANOID: ZingByteCodes,
    HEXAPOD: HexapodByteCodes,
}

// List all dance-related keys
const danceKeys = [
    'isDance',
    'isDance1',
    'isDance2',
    'isDance3',
    'isDance4',
    'isDance5',
]

const Remote = ({ webSerial, worker, device, socketData, deviceMismatch }) => {
    let history = useHistory()
    const connectedDevice = sessionStorage.getItem('connectedDevice')
    const deviceVersion = sessionStorage.getItem('deviceVersion')
    const isZing3 =
        connectedDevice === 'Humanoid' &&
        parseInt(deviceVersion?.split('.')?.[0] ?? '0') >= 3
    const issendAStopByte =
        (parseInt(deviceVersion?.split?.('.')?.[0] ?? '0') >= 3 ||
            parseInt(deviceVersion?.split?.('.')?.[2] ?? '0') >= 6) &&
        connectedDevice === 'Humanoid'
    const isZingFramed = isZingPlayFrameVersion(connectedDevice, deviceVersion)
    const getActionBytes = (name) => {
        const key = name.toUpperCase()
        if (isZingFramed && ZingPlayFrames[key]) return ZingPlayFrames[key]
        return ByteCodes[`${connectedDevice.toUpperCase()}`][key]
    }
    const attentionBytes = isZingFramed
        ? ZingPlayFrames.ATTENTION
        : ['R'.charCodeAt(0), 'a'.charCodeAt(0)]
    const [actionState, setActionState] = useState(
        ORIGINAL_ACTION_STATE[`${connectedDevice.toUpperCase()}`]
    )
    const [isBtnEnabled, setIsBtnEnabled] = useState(true)
    const [continousAction, setContinousAction] = useState()
    const [intervalId, setIntervalId] = useState(false)
    const [IsShowDanceDiv, setIsShowDanceDiv] = useState(false)
    const [showModel, setShowModel] = useState(false)
    const [showPushUpToast, setShowPushUpToast] = useState(false)
    // Push-Up must always run to completion; block other actions and Stop
    const blockIfPushUpRunning = () => {
        if (!actionState.isPushUp) return false
        setShowPushUpToast(true)
        return true
    }
    const [swipeActive, setSwipeActive] = useState('Manual')
    const [swiped, setSwiped] = useState(false)
    const [dances, setDances] = useState(() => {
        //only humanoid device version more than or equal to 3.0 it will work
        if (
            connectedDevice === 'Humanoid' &&
            parseInt(deviceVersion?.split('.')?.[0] ?? '0') >= 3
        ) {
            let localstorageDances = localStorage.getItem('dances')
            try {
                if (localstorageDances) {
                    localstorageDances = JSON.parse(localstorageDances)
                } else {
                    localstorageDances = DANCES
                }
            } catch {
                localstorageDances = DANCES
            }
            return localstorageDances[connectedDevice?.toUpperCase()] ?? []
        } else {
            return DANCES[connectedDevice?.toUpperCase()] ?? []
        }
    })
    const [customizeDanceModel, setCustomizeDanceModel] = useState({
        isShow: false,
        defaultDance: '',
        danceValue: '',
        fileArray: [],
        danceValueArrIndex: null,
    })
    const [showLoader, setShowLoader] = useState({
        isShow: false,
        isLoaderShow: false,
        message: '',
        isShowCloseBtn: false,
    })
    const [isStopActive, setIsStopActive] = useState(false)
    const isInitialRender = useRef(true)

    const sendDataAsPacket = useRef(false)
    const isIgnoreRdoneRef = useRef(false)
    const timeOutRef = useRef(null)
    const actionTokenRef = useRef(0)
    
    const activeDirectionRef = useRef(null)
    const languageName = device.language
    // const zingVersion = sessionStorage.getItem('zingVersion') || '0.0.0'

    //if zing version V0.1 than 5 dance not present there. there present only 1 dance that present in action panel
    if (connectedDevice == 'Humanoid' && deviceVersion.startsWith('0')) {
        if (!ACTIONS.HUMANOID.some((ele) => ele.name === 'Dance')) {
            ACTIONS.HUMANOID.push({ name: 'Dance', action: 'Dance' })
        }
    }

    // This function splits the data into packets of custom size
    // and also sends them at the given interval
    const timePromise = (ms) => {
        return new Promise((resolve, reject) => {
            timeOutRef.current = setTimeout(() => {
                resolve(true)
            }, ms)
        })
    }

    const checkDone = async () => {
        return new Promise(async (resolve, reject) => {
            while (true) {
                if (!sendDataAsPacket.current) {
                    if (timeOutRef.current) {
                        clearTimeout(timeOutRef.current)
                        timeOutRef.current = null
                    }
                    return resolve(true)
                }

                await new Promise((reslove) => {
                    setTimeout(reslove, 100)
                })
            }
        })
    }

    //for zing v2 write Data
    // const writeData_v2 = async (data) => {
    //     worker.postMessage({
    //         type: 'writeArray',
    //         value: data,
    //     })

    //     let waittime = 12000
    //     if (data[1] === 116 || data[1] === 115) {
    //         waittime = 90500
    //     }

    //     sessionStorage.setItem('sendDataAsPacket', 'true')
    //     let replyOK = await Promise.race([checkDone(), timePromise(waittime)])
    //     if (replyOK) {
    //         console.log('OK recieved')
    //         setActionState({
    //             ...ORIGINAL_ACTION_STATE[`${connectedDevice.toUpperCase()}`],
    //         })
    //         setIsBtnEnabled(true)
    //     }
    // }

    const writeData = async (data, action = '', token) => {
        const sentAt = Date.now()
        console.log(
            `[WAKEUP-DEBUG] (${action}) command bytes sent at`,
            new Date(sentAt).toISOString()
        )

        worker.postMessage({
            type: 'writeArray',
            value: data,
        })

        let waittime = 12000
        const isLongFramedAction =
            isZingPlayFrame(data) &&
            [
                'Dance',
                'Dance1',
                'Dance2',
                'Dance3',
                'Dance4',
                'PushUp',
                'Squat',
            ].includes(action)
        if (
            isLongFramedAction ||
            data[1] === 116 ||
            data[1] === 115 ||
            data[1] === 105 ||
            data[0] === 68 ||
            (data[0] === 80 && data[1] === 76 && data[2] === 68)
        ) {
            waittime = 92500
        }

        sendDataAsPacket.current = true

        let replyOK = await Promise.race([checkDone(), timePromise(waittime)])
        const elapsedMs = Date.now() - sentAt
        console.log(
            `[WAKEUP-DEBUG] (${action}) checkDone/timeout resolved after ${elapsedMs}ms` +
                ` (expected dance duration ~${waittime}ms) — replyOK=${replyOK}` +
                (elapsedMs < waittime
                    ? ' -> RDONE received EARLY, dance is likely still physically running'
                    : ' -> resolved via timeout, dance should be finished')
        )
        const isStale = token !== undefined && actionTokenRef.current !== token

        if (
            connectedDevice === 'Humanoid' &&
            ['2', '3'].includes(deviceVersion?.[0]) &&
            ['PushUp', 'Dance1', 'Dance2', 'Dance3', 'Dance4'].includes(action)
        ) {
            console.log(
                `[WAKEUP-DEBUG] (${action}) re-enabling wake-up/free-fall detection` +
                    ` ${elapsedMs}ms after command was sent (dance may still be running for up to ${waittime}ms)`
            )
            zingFreeFallSendBytes({ worker: worker, value: 1 })

            await new Promise((reslove) => {
                setTimeout(reslove, 100)
            })
            if (!isStale) setIsBtnEnabled(true)
        }

        if (replyOK) {
            if (isStale) {
                console.log(
                    `[WAKEUP-DEBUG] (${action}) resolved after being superseded by a newer action - ignoring reset`
                )
            } else {
                console.log('OK recieved')
                setActionState({
                    ...ORIGINAL_ACTION_STATE[
                        `${connectedDevice.toUpperCase()}`
                    ],
                })
                setIsBtnEnabled(true)
            }
        }
    }

    // Handling long click actions
    // useEffect(async () => {
    //     const handleContinuousAction = async () => {
    //         if (isInitialRender.current) {
    //             isInitialRender.current = false
    //             return
    //         }

    //         if (webSerial.isConnected) {
    //             // console.log(continousAction)

    //             let newActionState = { ...actionState }
    //             newActionState[`is${continousAction}`] = true
    //             setActionState({ ...newActionState })
    //             // actionState.current = newActionState

    //             await mouseActions()

    //             if (
    //                 !continousAction &&
    //                 !JSON.parse(sessionStorage.getItem('isClicked'))
    //             ) {
    //                 setTimeout(async () => {
    //                     worker.postMessage({
    //                         type: 'writeArray',
    //                         value: ['R'.charCodeAt(0), 'a'.charCodeAt(0)],
    //                     })

    //                     let replyOK = await Promise.race([
    //                         checkDone(),
    //                         timePromise(10000),
    //                     ])
    //                     if (replyOK) {
    //                         setActionState({
    //                             ...ORIGINAL_ACTION_STATE[
    //                                 `${connectedDevice.toUpperCase()}`
    //                             ],
    //                         })
    //                         // actionState.current = {
    //                         //     ...ORIGINAL_ACTION_STATE[
    //                         //         `${connectedDevice.toUpperCase()}`
    //                         //     ],
    //                         // }
    //                         setIsBtnEnabled(true)
    //                     }
    //                 }, 1500)
    //             }
    //         }
    //     }
    //     handleContinuousAction()
    // }, [continousAction])


    const handleFramedPress = (continousAction) => {
        if (activeDirectionRef.current === continousAction) return

        const bytes = getActionBytes(continousAction)
        if (!bytes) return

        if (activeDirectionRef.current) {
            worker.postMessage({ type: 'writeArray', value: attentionBytes })
        }

        activeDirectionRef.current = continousAction
        let newActionState = {
            ...ORIGINAL_ACTION_STATE[`${connectedDevice.toUpperCase()}`],
        }
        newActionState[`is${continousAction}`] = true
        setActionState({ ...newActionState })

        worker.postMessage({ type: 'writeArray', value: bytes })
    }

    const handleContinuousAction = async (continousAction) => {
        if (blockIfPushUpRunning()) return
        if (!webSerial.isConnected) return

        if (isZingFramed) {
            handleFramedPress(continousAction)
            return
        }

        {
            //------------------------------------------------------
            if (checkActionState(actionState)) {
                sendDataAsPacket.current = false

                await new Promise((reslove) => {
                    setTimeout(reslove, 100)
                })

                let newActionState = {
                    ...ORIGINAL_ACTION_STATE[
                        `${connectedDevice.toUpperCase()}`
                    ],
                }
                newActionState[`is${continousAction}`] = true
                setActionState({ ...newActionState })
                // actionState.current = newActionState

                worker.postMessage({
                    type: 'writeArray',
                    value: attentionBytes,
                })
                // sessionStorage.setItem('sendDataAsPacket', 'true')
                await new Promise((resolve) => setTimeout(resolve, 1500))
            } else {
                let newActionState = {
                    ...ORIGINAL_ACTION_STATE[
                        `${connectedDevice.toUpperCase()}`
                    ],
                }
                newActionState[`is${continousAction}`] = true
                setActionState({ ...newActionState })
            }
            //------------------------------------------------------

            // let newActionState = { ...actionState }
            // newActionState[`is${continousAction}`] = true
            // setActionState({ ...newActionState })

            await mouseActions(continousAction)
        }
    }

    // Release-to-stop handling for the framed (Zing 2.0-2.2) protocol: sends
    // ATTENTION exactly once, only if a direction is currently active.
    const handleFramedRelease = () => {
        if (!activeDirectionRef.current) return
        activeDirectionRef.current = null
        worker.postMessage({ type: 'writeArray', value: attentionBytes })
        setActionState({
            ...ORIGINAL_ACTION_STATE[`${connectedDevice.toUpperCase()}`],
        })
        setIsBtnEnabled(true)
    }

    //for continous action mouse up send 'Ra'
    const sendRa = () => {
        if (actionState.isPushUp) return
        if (isZingFramed) {
            handleFramedRelease()
            return
        }
        if (!JSON.parse(sessionStorage.getItem('isClicked'))) {
            setTimeout(async () => {
                worker.postMessage({
                    type: 'writeArray',
                    value: attentionBytes,
                })

                let replyOK = await Promise.race([
                    checkDone(),
                    timePromise(10000),
                ])
                if (replyOK) {
                    setActionState({
                        ...ORIGINAL_ACTION_STATE[
                            `${connectedDevice.toUpperCase()}`
                        ],
                    })
                    setIsBtnEnabled(true)
                }
            }, 1500)
        }
    }

    const mouseActions = async (continousAction) => {
        if (continousAction) {
            worker.postMessage({
                type: 'writeArray',
                value: getActionBytes(continousAction),
            })
            // sessionStorage.setItem('sendDataAsPacket', 'true')
            await new Promise((resolve) => setTimeout(resolve, 1500))
        }

        while (JSON.parse(sessionStorage.getItem('isClicked'))) {
            worker.postMessage({
                type: 'writeArray',
                value: getActionBytes(continousAction),
            })
            // sessionStorage.setItem('sendDataAsPacket', 'true')
            if (!JSON.parse(sessionStorage.getItem('isClicked'))) {
                break
            }
            await new Promise((resolve) => setTimeout(resolve, 1500))
        }
    }

    // setting isClicked --> false initially
    useEffect(() => {
        sessionStorage.setItem('flags', false)
    }, [])

    // If the user navigates away (or the device disconnects) while a
    // framed MOVE_DIR is active, stop the movement with one ATTENTION.
    useEffect(() => {
        return () => {
            if (isZingFramed && activeDirectionRef.current) {
                activeDirectionRef.current = null
                worker.postMessage({ type: 'writeArray', value: attentionBytes })
            }
        }
    }, [])

    useEffect(() => {
        if (
            isZingFramed &&
            !webSerial.isConnected &&
            activeDirectionRef.current
        ) {
            activeDirectionRef.current = null
        }
    }, [webSerial.isConnected, isZingFramed])

    //check any button enable
    const checkActionState = (actionObj) => {
        if (Object.values(actionObj).some((value) => value === true)) {
            return true
        } else return false
    }

    // Handling click events
    const handleAction = async (action) => {
        if (blockIfPushUpRunning()) return
        if (webSerial.isConnected) {
            const myToken = ++actionTokenRef.current
            //-----------------------------------------------------------------
            if (checkActionState(actionState)) {
                sendDataAsPacket.current = false

                await new Promise((reslove) => {
                    setTimeout(reslove, 100)
                })

                let newActionState = {
                    ...ORIGINAL_ACTION_STATE[
                        `${connectedDevice.toUpperCase()}`
                    ],
                }
                newActionState[`is${action}`] = true
                console.log('Humanoid action state', newActionState)
                setActionState({ ...newActionState })

                // Check if ANY dance key is true
                const isAnyDance = danceKeys.some(
                    (key) => actionState[key] === true
                )

                if (issendAStopByte && isAnyDance) {
                    isIgnoreRdoneRef.current = true
                    worker.postMessage({
                        type: 'writeArray',
                        value: [
                            'A'.charCodeAt(0),
                            'S'.charCodeAt(0),
                            'T'.charCodeAt(0),
                            'O'.charCodeAt(0),
                            'P'.charCodeAt(0),
                        ],
                    })

                    //after dance stop send the attention byte for give the smooth transfrom  give 1000ms weight
                    await new Promise((resolve) => setTimeout(resolve, 2000))
                    isIgnoreRdoneRef.current = false
                }

                worker.postMessage({
                    type: 'writeArray',
                    value: attentionBytes,
                })

                await new Promise((resolve) => setTimeout(resolve, 1500))
            } else {
                let newActionState = {
                    ...ORIGINAL_ACTION_STATE[
                        `${connectedDevice.toUpperCase()}`
                    ],
                }
                newActionState[`is${action}`] = true
                console.log('Humanoid action state', newActionState)
                setActionState({ ...newActionState })
                // actionState.current = newActionState
            }
            //-----------------------------------------------------------------

            console.log(`${connectedDevice} is ${action}ing...`)

            // let newActionState = { ...ORIGINAL_ACTION_STATE }
            // newActionState[`is${action}`] = true
            // console.log('Humanoid action state', newActionState)
            // setActionState({ ...newActionState })

            if (
                connectedDevice === 'Humanoid' &&
                ['2', '3'].includes(deviceVersion?.[0]) &&
                ['PushUp', 'Dance1', 'Dance2', 'Dance3', 'Dance4'].includes(
                    action
                )
            ) {
                console.log(
                    `[WAKEUP-DEBUG] (${action}) disabling wake-up/free-fall detection before dance starts at`,
                    new Date().toISOString()
                )
                zingFreeFallSendBytes({ worker: worker, value: 0 })
                if (issendAStopByte) {
                    if (action === 'PushUp') setIsBtnEnabled(false)
                } else {
                    setIsBtnEnabled(false)
                }
                await new Promise((reslove) => {
                    setTimeout(reslove, 100)
                })
            }

            let actionBytes = getActionBytes(action)
            if (['Dance1', 'Dance2', 'Dance3', 'Dance4'].includes(action)) {
                let currentSelectedDance = dances.find(
                    (d) => d.action === action
                )
                if (!currentSelectedDance.isDefault) {
                    let asciiActionByte = currentSelectedDance.name
                        .split('')
                        .map((char) => char.charCodeAt(0))
                    actionBytes = [
                        'P'.charCodeAt(0),
                        'L'.charCodeAt(0),
                        'D'.charCodeAt(0),
                        currentSelectedDance.name.length,
                        ...asciiActionByte,
                        'E'.charCodeAt(0),
                        'R'.charCodeAt(0),
                    ]
                }
            }
            writeData(actionBytes, action, myToken)
        }
    }

    const handelBackBtn = async () => {
        if (actionState.isPushUp) {
            setShowModel(true)
            setTimeout(() => {
                setShowModel(false)
            }, 1500)
            return
        }

        const myToken = ++actionTokenRef.current
        sendDataAsPacket.current = false
        await new Promise((resolve) => setTimeout(resolve, 100))

        // Check if ANY dance key is true
        const isAnyDance = danceKeys.some((key) => actionState[key] === true)

        if (issendAStopByte && isAnyDance) {
            isIgnoreRdoneRef.current = true
            worker.postMessage({
                type: 'writeArray',
                value: [
                    'A'.charCodeAt(0),
                    'S'.charCodeAt(0),
                    'T'.charCodeAt(0),
                    'O'.charCodeAt(0),
                    'P'.charCodeAt(0),
                ],
            })

            //after dance stop send the attention byte for give the smooth transfrom  give 1000ms weight
            await new Promise((resolve) => setTimeout(resolve, 1000))
            isIgnoreRdoneRef.current = false
        }

        writeData(attentionBytes, '', myToken)
        // await new Promise((resolve) => setTimeout(resolve, 2000))

        sessionStorage.setItem('slideDirection', true)
        history.push('/introduction')
    }

    const setSdCardMountPoint = async () => {
        let sdCardMountAt = await getMountPoint({
            socket: socketData.socket,
        })
        deviceMismatch({
            ...device,
            plodeNativeData: {
                ...device.plodeNativeData,
                mountPoint: sdCardMountAt,
            },
        })
        return sdCardMountAt
    }

    // On double-click of a dance item, fetch the custom actions
    // and open the customization dance popup.
    const danceHandelDoubleClick = async (action) => {
        try {
            if (!webSerial.isConnected) {
                setShowLoader({
                    isShow: true,
                    isLoaderShow: false,
                    message: 'Please connect the device.',
                    isShowCloseBtn: true,
                })
                return
            }

            setShowLoader({
                isShow: true,
                isLoaderShow: true,
                message: '',
                isShowCloseBtn: false,
            })
            let sdCardMountAt = device?.plodeNativeData?.mountPoint
            if (!sdCardMountAt) {
                sdCardMountAt = await setSdCardMountPoint()
            }
            // sessionStorage.getItem('sdCardMountAt') || 'NO NAME'
            let devicePathname = 'ZING'

            let filePath = `${sdCardMountAt}/${devicePathname}/actions/user/`

            //get the Lists all files in a directory on the mounted USB device.
            let listResponse = await getListFile({
                socket: socketData.socket,
                filePath: filePath,
            })

            if (listResponse.success) {
                setShowLoader({
                    isShow: false,
                    isLoaderShow: false,
                    message: '',
                    isShowCloseBtn: false,
                })

                const { fileArray } = convertFileArrFormat(listResponse)
                const defaultDanceName = `Dance ${action.slice(-1)}`
                fileArray.unshift(defaultDanceName)

                let selectedUiDance = dances.find((d) => d.action === action)
                let danceValueArrIndex = fileArray.indexOf(selectedUiDance.name)
                // fall back to the default dance if the previously selected
                // custom action no longer exists on the SD card
                if (danceValueArrIndex === -1) {
                    danceValueArrIndex = 0
                }
                setCustomizeDanceModel({
                    isShow: true,
                    defaultDance: action,
                    fileArray,
                    danceValue: fileArray[danceValueArrIndex],
                    danceValueArrIndex,
                })
            } else {
                if (listResponse.error.includes('Error reading directory')) {
                    setShowLoader({
                        isShow: true,
                        isLoaderShow: false,
                        message:
                            'No custom actions are available on your Zing device.',
                        isShowCloseBtn: true,
                    })
                } else
                    setShowLoader({
                        isShow: true,
                        isLoaderShow: false,
                        message: 'Action group can not open try again .....',
                        isShowCloseBtn: true,
                    })
            }
        } catch (e) {
            console.log(e)
            setShowLoader({
                isShow: true,
                isLoaderShow: false,
                message: 'Action group can not open try again .....',
                isShowCloseBtn: true,
            })
        }
    }

    const changeDance = async () => {
        try {
            const selectedDance = customizeDanceModel.danceValue
            if (!selectedDance) {
                // alert("Please select a dance.");
                return
            }

            let updatedDances = dances
            if (customizeDanceModel.danceValueArrIndex === 0) {
                updatedDances = dances.map((d) =>
                    d.action === customizeDanceModel.defaultDance
                        ? { ...d, name: selectedDance, isDefault: true } // replace old dance with new selection
                        : d
                )
            } else {
                // Update UI dance name
                updatedDances = dances.map((d) =>
                    d.action === customizeDanceModel.defaultDance
                        ? { ...d, name: selectedDance, isDefault: false } // replace old dance with new selection
                        : d
                )
            }
            setDances(updatedDances)

            // Save back into localStorage under device key
            let localstorageDances = localStorage.getItem('dances')
            localstorageDances = localstorageDances
                ? JSON.parse(localstorageDances)
                : DANCES

            localstorageDances[connectedDevice?.toUpperCase()] = updatedDances

            localStorage.setItem('dances', JSON.stringify(localstorageDances))

            // Close popup
            setCustomizeDanceModel({
                isShow: false,
                danceValue: '',
                defaultDance: '',
                fileArray: [],
                danceValueArrIndex: null,
            })

            // console.log('Dance updated:', selectedDance)
        } catch (err) {
            console.log('Error updating dance:', err)
            // alert('Something went wrong while updating the dance.')
        }
    }
    const handelStopBytes = async () => {
        if (blockIfPushUpRunning()) return
        setIsStopActive(true)
        setTimeout(() => setIsStopActive(false), 600)

        const myToken = ++actionTokenRef.current
        sendDataAsPacket.current = false
        await new Promise((resolve) => setTimeout(resolve, 100))

        setActionState({
            ...ORIGINAL_ACTION_STATE[`${connectedDevice.toUpperCase()}`],
        })
        setIsBtnEnabled(true)

        // Check if ANY dance key is true
        const isAnyDance = danceKeys.some((key) => actionState[key] === true)

        if (issendAStopByte && isAnyDance) {
            isIgnoreRdoneRef.current = true
            worker.postMessage({
                type: 'writeArray',
                value: [
                    'A'.charCodeAt(0),
                    'S'.charCodeAt(0),
                    'T'.charCodeAt(0),
                    'O'.charCodeAt(0),
                    'P'.charCodeAt(0),
                ],
            })

            //after dance stop send the attention byte for give the smooth transfrom  give 1000ms weight
            await new Promise((resolve) => setTimeout(resolve, 1000))
            isIgnoreRdoneRef.current = false
        }

        // worker.postMessage({
        //     type: 'writeArray',
        //     value: ['R'.charCodeAt(0), 'a'.charCodeAt(0)],
        // })
        writeData(attentionBytes, '', myToken)
    }

    const isShowHelpButton = () => {
        if (isZing3 && swipeActive !== 'Auto') {
            return true
        } else if (connectedDevice == 'Humanoid' && !isZing3) {
            return true
        } else return false
    }

    useEffect(() => {
        const handleBytesSending = async () => {
            let assetsToBeCached = [
                // helpScreen
                renderImage('remoteH'),
                renderImage('remoteH1'),
                renderImage('remoteH2'),
                renderImage('Remt1'),
                renderImage('Remt2'),
                renderImage('Remt3'),
                renderImage('Remt4'),
                renderImage('Remt5'),
                renderImage('Remt6'),
                renderImage('PlayH1'),
                renderImage('PlayH2'),
                renderImage('PlayH3'),
                renderImage('PlayH4'),
                renderImage('PlayH5'),
                renderImage('PlayH6'),
                renderImage('PlayH7'),
                renderImage('PlayH8'),
                renderImage('PlayH9'),
            ]
            cacheAssets(assetsToBeCached)
            if (webSerial.isConnected) {
                const PLAY = [
                    'P'.charCodeAt(),
                    'L'.charCodeAt(),
                    'A'.charCodeAt(),
                    'Y'.charCodeAt(),
                ]
                // const M8 = ['M'.charCodeAt(), '8'.charCodeAt()]
                const Attention = ['R'.charCodeAt(), 'a'.charCodeAt()]
                if (
                    connectedDevice == 'Ace' &&
                    sessionStorage.getItem('deviceVersion')?.startsWith('1')
                )
                    return

                await new Promise((reslove) => setTimeout(reslove, 200))
                writePort(PLAY)

                if (connectedDevice == 'Hexapod') {
                    setTimeout(async () => {
                        writePort(Attention)
                    }, 200)
                    await new Promise((resolve, reject) =>
                        setTimeout(() => {
                            resolve()
                        }, 200)
                    )
                }
                setTimeout(() => {})
            }
        }
        handleBytesSending()
    }, [webSerial.isConnected])
    async function writePort(data) {
        worker.postMessage({
            type: 'writeArray',
            value: data,
        })
        console.log('PlayBytes Sent')
    }

    //recived the data for zing v2
    useEffect(() => {
        const messageHandler = (e) => {
            if (e.data.type === 'read') {
                let combinedResult = e.data.value
                if (
                    (combinedResult.includes('RDONE') ||
                        combinedResult.includes('Rdone')) &&
                    !isIgnoreRdoneRef.current
                ) {
                    console.log(
                        '[WAKEUP-DEBUG] RDONE received from device at',
                        new Date().toISOString(),
                        '-> raw reply:',
                        combinedResult,
                        '(this is treated as "dance finished", but the robot may still be physically moving/bending)'
                    )
                    sendDataAsPacket.current = false
                }
            }
        }
        worker.addEventListener('message', messageHandler)

        // return worker.removeEventListener('message', messageHandler)
    }, [])

    return (
        <>
            <Toast
                show={showPushUpToast}
                message="Please wait for the action to complete!"
                onClose={() => setShowPushUpToast(false)}
            />
            <DialogModal
                show={showModel}
                text="Please wait for the action to complete."
                // showCloseBtn={true}
            />
            <DialogModal
                show={showLoader.isShow}
                text={
                    <div>
                        {showLoader.isLoaderShow && (
                            <p>Fetch custom actions...</p>
                        )}
                        {showLoader.message && <p>{showLoader.message}</p>}
                    </div>
                }
                showCloseBtn={showLoader.isShowCloseBtn}
                handleDialogModalClose={() =>
                    setShowLoader({
                        isShow: false,
                        isLoaderShow: false,
                        message: '',
                        isShowCloseBtn: false,
                    })
                }
            />

            <DialogModal
                show={customizeDanceModel.isShow}
                text={
                    <div>
                        <p>Customize {customizeDanceModel.defaultDance}</p>
                        <div>
                            <select
                                className={remoteStyle.language_select}
                                value={customizeDanceModel.danceValue}
                                onChange={(e) =>
                                    setCustomizeDanceModel({
                                        ...customizeDanceModel,
                                        danceValue: e.target.value,
                                        danceValueArrIndex:
                                            customizeDanceModel.fileArray.indexOf(
                                                e.target.value
                                            ),
                                    })
                                }
                            >
                                {customizeDanceModel.fileArray.map((ele) => {
                                    return <option value={ele}>{ele}</option>
                                })}
                            </select>
                        </div>
                    </div>
                }
                showCloseBtn={true}
                handleDialogModalClose={() =>
                    setCustomizeDanceModel({
                        isShow: false,
                        danceValue: '',
                        defaultDance: '',
                        fileArray: [],
                        danceValueArrIndex: null,
                    })
                }
                optionsToSelect={[
                    {
                        text: 'Confirm',
                        do: () => {
                            changeDance()
                        },
                    },
                ]}
            />

            <div
                className={remoteStyle['remote-container']}
                style={
                    swiped && swipeActive === 'Auto' && isZing3
                        ? { background: '#FFF2EF' }
                        : {}
                }
            >
                <MainHeader
                    title={languageWords[languageName]?.Joystick || 'Joystick'}
                    showBluetoothBtn={true}
                    helper={isShowHelpButton() ? <RemSlider /> : ''}
                    goBack={handelBackBtn}
                    isShowStopIcon={
                        issendAStopByte && swipeActive !== 'Auto' ? true : false
                    }
                    isStopIconActive={isStopActive}
                    handelStopBytes={handelStopBytes}
                    btns={['Manual', 'Auto']}
                    swipeBtnStyles={{
                        aiActive: { width: '80px' },
                        customActive: {
                            width: '75px',
                            transform: 'translateX(75px)',
                        },
                        wrapper: { width: '165px' },
                        aiBtn: { width: '80px' },
                    }}
                    isShowAiSwipeBtn={isZing3}
                    swipeActive={swipeActive}
                    setSwipeActive={setSwipeActive}
                />

                {connectedDevice === 'Humanoid' ? (
                    swipeActive === 'Auto' ? (
                        <div>
                            <JoystickAutoMode
                                swiped={swiped}
                                setSwiped={setSwiped}
                            />
                        </div>
                    ) : (
                        <div style={{ height: '80%' }}>
                            <div className={remoteStyle['sub-container']}>
                                <div></div>
                                <div
                                    className={
                                        remoteStyle['joystick-container']
                                    }
                                >
                                    <Jyostick
                                        actionState={actionState}
                                        isEnabled={isBtnEnabled}
                                        sendBytes={sendBytes}
                                        setContinousAction={setContinousAction}
                                        handleAction={handleAction}
                                        handleContinuousAction={
                                            handleContinuousAction
                                        }
                                        sendRa={sendRa}
                                    />
                                </div>
                                <div className={remoteStyle['zing-container']}>
                                    <img
                                        src={
                                            getConnectedDeviceImage(
                                                connectedDevice,
                                                deviceVersion
                                            ) ||
                                            (deviceVersion?.startsWith('3')
                                                ? zingimage3
                                                : zingimage)
                                        }
                                    />
                                </div>
                                {/* State Icon */}

                                <div
                                    className={remoteStyle['button-container']}
                                >
                                    <div
                                        className={`${
                                            remoteStyle['action-container']
                                        } ${remoteStyle['show-action']}`}
                                    >
                                        <div
                                            // className={remoteStyle['actionBar-item-1']}
                                            className={
                                                remoteStyle[
                                                    `actionBar-item-1-${connectedDevice.toLowerCase()}`
                                                ]
                                            }
                                        >
                                            {ACTIONS[
                                                connectedDevice.toUpperCase()
                                            ]
                                                .map((key) => (
                                                    <ActionCard
                                                        key={key.action}
                                                        name={key.name}
                                                        action={key.action}
                                                        isOn={
                                                            actionState[
                                                                `is${key.action}`
                                                            ]
                                                        }
                                                        isEnabled={isBtnEnabled}
                                                        // isEnabled={false}
                                                        handleAction={
                                                            handleAction
                                                        }
                                                    />
                                                ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                ) : (
                    <div
                        style={{
                            height: '100%',
                            width: '100%',
                            display: 'grid',
                            gridTemplateColumns: '5% 28% 34% 33%',
                            position: 'absolute',
                            top: '29%',
                        }}
                    >
                        <div></div>
                        <div style={{ height: '46%', width: '100%' }}>
                            <Jyostick
                                actionState={actionState}
                                isEnabled={isBtnEnabled}
                                sendBytes={sendBytes}
                                setContinousAction={setContinousAction}
                                handleAction={handleAction}
                                continousAction={continousAction}
                                handleContinuousAction={handleContinuousAction}
                                sendRa={sendRa}
                            />
                        </div>
                        <div>
                            <img
                                style={{
                                    position: 'absolute',
                                    height: '45%',
                                    width: '27%',
                                    left: '35%',
                                }}
                                src={
                                    getConnectedDeviceImage(
                                        connectedDevice,
                                        deviceVersion
                                    ) ||
                                    (deviceVersion?.startsWith('2.2')
                                        ? renderImage('crawleV22')
                                        : hexapodImage)
                                }
                            />
                        </div>
                        <div
                            style={{
                                height: '38%',
                                width: '72%',
                                display: 'grid',
                                gap: '8px',
                                gridTemplateColumns: 'auto auto auto auto',
                                alignItems: 'inherit',
                            }}
                        >
                            {ACTIONS[connectedDevice.toUpperCase()].map(
                                (key) => (
                                    <ActionCard
                                        key={key.action}
                                        name={key.name}
                                        action={key.action}
                                        isOn={actionState[`is${key.action}`]}
                                        isEnabled={isBtnEnabled}
                                        handleAction={handleAction}
                                    />
                                )
                            )}
                        </div>
                        {/* <div></div> */}
                    </div>
                )}
            </div>
        </>
    )
}
const mapStateToProps = (state) => {
    return state
}
const mapDispatchToProps = (dispatch) => {
    return {
        deviceMismatch: (data) => {
            dispatch({ type: 'DEVICE_MISMATCH', payload: data })
        },
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(Remote)
